import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';

export const HOMEOWNER_ONBOARDING = '5fe9ae59-0ba2-4251-a715-da48f827005d';
export const BRANDING_AND_CONTENT = 'b48e0fde-a2d6-4cc8-8a65-b14647203bc0';
export const HOME_SERVICES_AND_CO_MARKETING = '617b3d5d-70ee-4bbb-8a05-607fedb8a25f';
export const ESSENTIALS = 'a5e9aa83-3a09-4794-be48-1d844f518f08';
export const ENTERPRISE_ENHANCEMENTS = '4de652c6-c95b-461b-999b-00c6bbcacae8';

class LuSubscriptionPlanFeatureCategoryAppResource extends AppResource {

  /**
   * @returns {string}
   */
  appResourceType() {
    return 'lu-subscription-plan-feature-category';
  }

  /**
   * @returns {string}
   */
  appResourceApiPrefix() {
    return 'lus/subscriptions/plans/features/categories';
  }

  /**
   * @returns {*[]}
   */
  hidden() {
    return super.hidden().concat([
      'uuid',
      'deleted_at',
    ]);
  }

  /**
   * @returns {*[]}
   */
  fillable() {
    return [
      'title',
      'slug',
      'description',
      'order',
    ];
  }

  /**
   * @returns {*[]}
   */
  relationMap() {
    return [
    ];
  }

  /**
   * @returns {*[]}
   */
  relationForeignKeys() {
    return [
    ];
  }

  /**
   * @returns {*}
   */
  validationRules() {
    return {
      title: {
        type: 'string',
        presence: true,
        length: {
          maximum: 255,
        },
      },
      slug: {
        type: 'string',
        presence: true,
        length: {
          maximum: 255,
        },
      },
      description: {
        type: 'string',
        length: {
          maximum: 255,
        },
      },
      order: {
        type: 'integer',
        presence: true,
      },
    };
  }

}

export default LuSubscriptionPlanFeatureCategoryAppResource;
